import React, { useEffect, useState } from "react";
import AdminNavbar from "../../../components/admin_navbar";
import AdminSideMenu from "../../../components/admin_side_menu";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Pagination from "bulma-pagination-react";

const Stores = () => {
  const navigate = useNavigate();
  var apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();

  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [stores, setStores] = useState([]);
  const [per, setPer] = useState(8);
  const [pageCount, setPageCount] = useState(1);

  useEffect(() => {
    let accessToken = localStorage.getItem("strutspos_access_token");
    if (!accessToken) {
      navigate("/");
    }

    window.scrollTo(0, 0);
    setCurrentPage(1);
    setPer(8);

    const currentDate = new Date();
    const previousDay = new Date(currentDate);
    previousDay.setDate(currentDate.getDate() - 1);

    const nextDay = new Date(currentDate);
    nextDay.setDate(currentDate.getDate() + 1);

    setStartDate(previousDay);
    setEndDate(nextDay);

    var url = apiBaseURL + "/stores?per=" + per;

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let storesData = JSON.parse(JSON.stringify(response.data));
        let storesCount = storesData.pagination.count;
        setCount(storesCount);
        setStores(storesData.stores);

        let numPages = Math.ceil(storesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("fetchStores err = " + err.message));
  }, [apiBaseURL, per, navigate]);

  const searchStores = (searchTermText) => {
    var accessToken = localStorage.getItem("strutspos_access_token");
    var url = apiBaseURL + "/stores?search=" + searchTermText;

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let storesData = JSON.parse(JSON.stringify(response.data));
        let storesCount = storesData.pagination.count;
        setCount(storesCount);
        setStores(storesData.stores);

        let numPages = Math.ceil(storesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("searchStores err = " + err.message));
  };

  const handlePageClick = (data) => {
    filterStores(data);
  };

  const filterStores = (data) => {
    var selectedPage = data;
    setCurrentPage(selectedPage);
    var accessToken = localStorage.getItem("strutspos_access_token");

    axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
    var url = apiBaseURL + "/stores?page=" + selectedPage + "&per=" + per;

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let storesData = JSON.parse(JSON.stringify(response.data));
        let storesCount = storesData.pagination.count;
        setCount(storesCount);
        setStores(storesData.stores);

        let numPages = Math.ceil(storesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("filter Stores err = " + err.message));
  };

  const dateFilterStores = (dateStart, dateEnd) => {
    var accessToken = localStorage.getItem("strutspos_access_token");

    axios.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
    var url =
      apiBaseURL +
      "/stores?page=1&per=" +
      per +
      "&start_date=" +
      dateStart +
      "&end_date=" +
      dateEnd;

    const config = {
      headers: {
        "x-strutspos-token": accessToken,
        "x-strutspos-application": "user",
      },
    };

    axios
      .get(url, config)
      .then((response) => {
        let storesData = JSON.parse(JSON.stringify(response.data));
        let storesCount = storesData.pagination.count;
        setCount(storesCount);
        setStores(storesData.stores);

        let numPages = Math.ceil(storesCount / per);
        setPageCount(numPages);
      })
      .catch((err) => console.error("filter Stores err = " + err.message));
  };

  const downloadExcelStores = async () => {
    try {
      const formattedStartDate = startDate.toISOString().split("T")[0];
      const formattedEndDate = endDate.toISOString().split("T")[0];

      var accessToken = localStorage.getItem("strutspos_access_token");
      var apiURL =
        apiBaseURL +
        "/stores/download?page=1&per=" +
        1000 +
        "&start_date=" +
        formattedStartDate +
        "&end_date=" +
        formattedEndDate;

      const response = await axios.get(apiURL, {
        responseType: "blob",
        headers: {
          "x-strutspos-token": accessToken,
          "x-strutspos-application": "user",
        },
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "stores.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const updateStartDate = (date) => {
    setStartDate(date);

    const formattedStartDate = date.toISOString().split("T")[0];
    const formattedEndDate = endDate.toISOString().split("T")[0];

    // Filter stores based on start and end dates
    dateFilterStores(formattedStartDate, formattedEndDate);
  };

  const updateEndDate = (date) => {
    setEndDate(date);

    const formattedStartDate = startDate.toISOString().split("T")[0];
    const formattedEndDate = date.toISOString().split("T")[0];

    // Filter stores based on start and end dates
    dateFilterStores(formattedStartDate, formattedEndDate);
  };

  const handleScroll = (event) => {
    const container = event.target;
    const scrollAmount = event.deltaY;
    container.scrollTo({
      top: 0,
      left: container.scrollLeft + scrollAmount,
      behavior: "smooth",
    });
  };

  return (
    <div className="modern-admin-layout">
      <AdminNavbar />

      <div className="admin-container">
        <div className="admin-sidebar">
          <AdminSideMenu />
        </div>

        <main className="admin-main-content">
          {/* Modern Stores Header */}
          <div className="dashboard-header-modern">
            <div className="dashboard-header-content">
              <h1 className="dashboard-title">Stores</h1>
              <p className="dashboard-subtitle">
                Manage and view all stores ({count} total)
              </p>
            </div>
          </div>

          {/* Filters and Controls Card */}
          <div className="filters-card-modern">
            <div className="filters-header">
              <h3>Filters & Controls</h3>
            </div>

            <div className="filters-grid">
              <div className="filter-group">
                <label className="filter-label">From Date:</label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => updateStartDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="modern-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">To Date:</label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => updateEndDate(date)}
                  dateFormat="yyyy-MM-dd"
                  className="modern-input"
                />
              </div>

              <div className="filter-group">
                <label className="filter-label">Search:</label>
                <input
                  className="modern-input"
                  type="text"
                  placeholder="Search stores..."
                  name="search"
                  onChange={(e) => searchStores(e.target.value)}
                />
              </div>

              <div className="filter-group">
                <button
                  className="modern-button primary"
                  onClick={() => downloadExcelStores()}
                >
                  📊 Export Excel
                </button>
              </div>
            </div>
          </div>

          {/* Stores Table Card */}
          <div className="table-card-modern">
            <div className="table-header">
              <h3>Stores List</h3>
              <span className="table-count">{count} stores</span>
            </div>

            <div className="table-container-modern" onWheel={handleScroll}>
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone Number</th>
                    <th>Email</th>
                    <th>Location</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {stores.map((store) => (
                    <tr key={store.id}>
                      <td className="font-semibold">{store.name}</td>
                      <td>{store.phone_number}</td>
                      <td>{store.email}</td>
                      <td>{store.location}</td>
                      <td>{store.created_at.substring(0, 10)}</td>
                      <td>
                        <Link
                          to={{ pathname: `/stores/${store.id}` }}
                          className="modern-button small primary"
                        >
                          View
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="pagination-container-modern">
              <Pagination
                pages={pageCount}
                currentPage={currentPage}
                onChange={(page) => handlePageClick(page)}
              />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Stores;
